<template>
  <section class="text-center py-12 min-h-screen-3/4">
    <h1 class="text-shade my-4 font-bold text-[22px] leading-[30.8px] text-center lg:text-[35px]">How often would you like to donate?</h1>

    <div class="flex flex-col items-center justify-center gap-y-[42px] mt-[72px] lg:flex-row lg:mt-[61px]">

      <button @click="repetition = 'Month'" class="rounded-full min-w-[240px] lg:min-w-max border-4 px-[30px] lg:px-5 py-[10px] lg:text-[35px] lg:leading-[22px] font-bold text-[17px] leading-6 lg:py-[25px] uppercase" :class="[
        repetition == 'Month'
          ? 'bg-primary text-white border-primary ring-2 ring-primary'
          : ' border-primary text-black'
      ]">
        Monthly
      </button>
      <button @click="repetition = 'Quarter'" class="rounded-full min-w-[240px] lg:min-w-max border-4 px-[30px] lg:px-5 py-[10px] lg:text-[35px] lg:leading-[22px] font-bold text-[17px] leading-6 lg:py-[25px]  lg:mx-[67px]  uppercase" :class="[
        repetition == 'Quarter'
          ? 'bg-primary text-white border-primary ring-2 ring-primary'
          : ' border-primary text-black'
      ]">
        Quarterly
      </button>
      <button @click="repetition = 'Year'" class="rounded-full min-w-[240px] lg:min-w-max border-4 px-[30px] lg:px-5 py-[10px] lg:text-[35px] lg:leading-[22px] font-bold text-[17px] leading-6 lg:py-[25px] uppercase" :class="[
        repetition == 'Year'
          ? 'bg-primary text-white border-primary ring-2 ring-primary'
          : ' border-primary text-black'
      ]">
        Annually
      </button>




    </div>

    <div v-if="repetition" class="mt-[130px] text-center">
      <h1 class="font-bold text-[22px] leading-[30.8px] text-shade text-center lg:text-[35px] lg:leading-[42px]">
        When would you like this to start?
      </h1>

      <p class="mt-[11px] font-normal font-karla text-[17px] leading-[26px] text-center text-shade lg:text-xl lg:leading-6 lg:tracking-[0.64px] lg:mt-8">
        Donations can be taken on the 1st or 15th of the month
      </p>

      <div class="flex flex-col gap-6 lg:flex-row items-center justify-center container mt-[44px] lg:mt-[74px]">

        <button data-testid="start-date-1" class="rounded-full min-w-[240px] lg:max-w-max border-4 px-[30px] lg:px-5 py-[10px] lg:text-[30px] lg:leading-[22px] font-bold text-[17px] leading-6 lg:py-[25px] border-primary" :class="[firstMonthIsEarlier ? 'order-first':'order-last' ]" @click="
          startDate = 1;
        nextStep();
        ">
          {{ firstMonth }}
        </button>

        <button data-testid="start-date-15" class="rounded-full min-w-[240px] lg:max-w-max  border-4 px-[30px] lg:px-5 py-[10px] lg:text-[30px] lg:leading-[22px] font-bold text-[17px] leading-6 lg:py-[25px] border-primary" :class="[firstMonthIsEarlier ? 'order-last':'order-first' ]" @click="
          startDate = 15;
        nextStep();
        ">
          {{ fifteenthMonth }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    firstMonth: function () {
      let nextFirst = this.$dayjs()
        .add(1, "month")
        .startOf("month");

      // is this within the next ten days?
      if (
        this.$dayjs()
          .add(10, "days")
          .isAfter(nextFirst)
      ) {
        nextFirst = nextFirst.add(1, "month");
      }

      return nextFirst.format("D MMMM YYYY");
    },

    fifteenthMonth: function () {
      let nextFifteenth = this.$dayjs()
        .add(1, "month")
        .date(15);

      // is this within the next ten days?
      if (
        this.$dayjs()
          .add(10, "days")
          .isAfter(nextFifteenth)
      ) {
        nextFifteenth = nextFifteenth.add(1, "month");
      }

      return nextFifteenth.format("D MMMM YYYY");
    },
    firstMonthIsEarlier: function () {
      const nextFirst = this.$dayjs(this.firstMonth, "D MMMM YYYY");
      const nextFifteenth = this.$dayjs(this.fifteenthMonth, "D MMMM YYYY");

      return nextFirst.isBefore(nextFifteenth);
    }
  },

  data() {
    return {
      repetition: null,
      startDate: null
    };
  },

  methods: {
    nextStep() {
      this.$emit("nextStep", {
        paymentFrequency: this.repetition,
        collectionDay: this.startDate,
        collectionDate:
          this.startDate === 1 ? this.firstMonth : this.fifteenthMonth
      });
    }
  },

  props: {},
};
</script>
